import React from 'react';
import { AiOutlineLink } from 'react-icons/ai';
import laptop from '../../img/png/menu_healthcare.png';

const MenuHealth = ({ isActive }) => {
  return (
    <>
      <div className={`menu_health ${isActive} `}>
        <div className='menu_health_container d-flex-row justify-content-between'>
          <div className='menu_health_container_left d-flex-col gap-2'>
            <p className='text-gray'>
              SQREEM has built a technology that combines vast amounts of data
              with next generation artificial intelligence to identify, analyze,
              understand and reach HCPs, patients, and consumers in any market
              and therapeutic area, at any time.
            </p>
            <img src={laptop} alt='background img' />
            <p className='text-gray'>
              The new relationship between brand and HCP is genuine, sustained,
              interpersonal, yet entirely digital. Find out how we are able to
              target HCPs with 95%+ accuracy.
            </p>
            <a
              target='_blank'
              rel='noopener noreferrer'
              href='https://www.youtube.com/watch?v=97IMKmmgRAU'
            >
              <button
                href='#contact'
                className='d-flex-row align-items-center justify-content-center'
              >
                <AiOutlineLink /> Case study
              </button>
            </a>
          </div>
          <div className='menu_health_container_right d-flex-col gap-3'>
            <h2 className='text-subtitle'>
              Full campaign integration into one cohesive workflow
            </h2>
            <div className='bullet d-flex-col gap-3'>
              <div className='bullet_item d-flex-row align-items-center gap-2'>
                <span>1</span>
                <div className='d-flex-col'>
                  <h3 className=''>Understanding your audience</h3>
                  <p className='text-gray'>Leveraging data at scale.</p>
                </div>
              </div>
              <div className='bullet_item d-flex-row align-items-center gap-2'>
                <span>2</span>
                <div className='d-flex-col'>
                  <h3 className=''>Reaching your audience</h3>
                  <p className='text-gray'>
                    Transform data into targetable and actionable insights.
                  </p>
                </div>
              </div>
              <div className='bullet_item d-flex-row align-items-center gap-2'>
                <span>3</span>
                <div className='d-flex-col'>
                  <h3 className=''>Engaging your audience</h3>
                  <p className='text-gray'>
                    Use insights to reach target audiences intelligently and
                    seamlessly.
                  </p>
                </div>
              </div>
              <div className='bullet_item d-flex-row align-items-center gap-2'>
                <span>4</span>
                <div className='d-flex-col'>
                  <h3 className=''>Sustaining the engagement</h3>
                  <p className='text-gray'>
                    Leveraging consent to build longer term relationships.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuHealth;
